import { createActions } from 'reduxsauce';
import { setAddressProps } from "../../util/menu/setAddressProps";

var _createActions = createActions({
  logoutSuccess: ['logoutSuccess'],
  loginSuccess: function loginSuccess(aadResponse) {
    return {
      type: 'LOGIN_SUCCESS',
      aadResponse: aadResponse
    };
  },
  storeLoginSuccess: function storeLoginSuccess(aadResponse) {
    return {
      type: 'AAD_STORE_LOGIN_SUCCESS',
      aadResponse: aadResponse
    };
  },
  fetchAddress: ['fetchAddress'],
  getAddress: function getAddress(json) {
    return {
      type: 'AAD_GET_ADDRESS',
      addresses: json.data.addresses
    };
  },
  receiveAddress: function receiveAddress(item, addressType) {
    var fields = setAddressProps(item, addressType);
    var address = {};

    for (var property in fields) {
      address[fields[property]] = item[property];
    }

    return {
      type: 'AAD_RECEIVE_ADDRESS',
      address: address,
      addressType: addressType
    };
  },
  postAddress: ['postAddress'],
  deleteAddress: ['deleteAddress'],
  toReturn: ['toReturn'],
  setShowReplacement: ['showReplacement'],
  returnOrder: [],
  responseReturnOrder: ['orders'],
  errorGuestOrder: [],
  responseReOrder: function responseReOrder(reOrderSuccess) {
    return {
      type: 'AAD_RESPONSE_RE_ORDER',
      reOrderSuccess: reOrderSuccess
    };
  },
  requestGetOrders: function requestGetOrders() {
    return {
      type: 'AAD_REQUEST_GET_ORDERS'
    };
  },
  getOrders: function getOrders(json) {
    var _json$Data;

    return {
      type: 'AAD_GET_ORDERS',
      orders: json === null || json === void 0 ? void 0 : (_json$Data = json.Data) === null || _json$Data === void 0 ? void 0 : _json$Data.Orders
    };
  },
  requestGuestOrder: function requestGuestOrder(json) {
    return {
      type: 'AAD_REQUEST_GUEST_ORDER'
    };
  },
  responseGuestOrder: function responseGuestOrder(json) {
    return {
      type: 'AAD_RESPONSE_GUEST_ORDER',
      orders: json.orders
    };
  },
  receiveAccountDetails: function receiveAccountDetails(json) {
    return {
      type: 'AAD_RECEIVE_ACCOUNT_DETAILS',
      registerLogin: json.registerLogin
    };
  },
  responseReturnOrderErr: []
}, {
  prefix: 'AAD_' // Set prefix to match aadl package

}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};